import React, { useState, useEffect, } from "react";
import { Modal, Button, Card,  } from 'antd';
import notification from '../../../services/notification';
import { PenIcon, CheckSquareIcon, XIcon, } from "@phosphor-icons/react";
import { useNavigate, } from 'react-router';
import { FormattedMessage, useIntl, } from "react-intl";
import { useForm, } from "react-hook-form";
import { UserUpdate, GetCustomerUsergroups, } from '../../../services/users';
import UserFormView from './views/user.form.view';


const EditUserModal = ({
    modalIsOpen,
    modalIsOpenHandler,
    userProfileData,
    refreshData,
    ...props
}) => {

    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [userGroups, setUserGroups] = useState(undefined);

    const { handleSubmit, reset, control } = useForm();
    const intl = useIntl();
    const history = useNavigate();


    useEffect(() => {
        getUsergroups();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
        if (userGroups) {
            // getting the usergroup id:
            const user_group_id = userGroups.find(ug => ug.label === userProfileData.user_data.user_group || ug.value === userProfileData.user_data.user_group)?.value;

            // setup correct data object for form reset
            const formdata = {
                "user_email": userProfileData.user_email,
                "user_phone_number": userProfileData.user_data.user_phone_number,
                "user_first_name": userProfileData.user_data.user_first_name,
                "user_last_name": userProfileData.user_data.user_last_name,
                "customer_id": userProfileData.customer_id,
                "user_note": userProfileData.user_data?.user_note,
                "user_language": userProfileData.user_data?.user_language,
                "user_group": user_group_id,
                "user_ip_validation_disabled": userProfileData?.user_ip_validation_disabled,
            }
            reset(formdata);
        }
        return () => {
            // cleanup
        }
        // below line needed to remove the warning on build.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userProfileData, userGroups,])

    const getUsergroups = () => {
        GetCustomerUsergroups(userProfileData.customer_id, history)
            .then(response => {
                if (response.status) {
                    var tmp = [];
                    for (let i = 0; i < response.data.user_groups.length; i++) {
                        tmp.push({
                            value: response.data.user_groups[i].ug_id,
                            label: response.data.user_groups[i].ug_name
                        });
                    }
                    // adding the build-in groups
                    tmp.push({
                        value: 'users',
                        label: 'Users (Built-in)'
                    });
                    tmp.push({
                        value: 'administrators',
                        label: 'Administrators (Built-in)'
                    });

                    setUserGroups(tmp);
                }
            })
            .catch(error => { });
    };

    const onSubmit = (data) => {
        setButtonDisabled(true);
        const postdata = {
            "user_id": userProfileData.user_id,
            "customer_id": userProfileData.customer_id,
            ...data
        };

        UserUpdate(postdata, history)
            .then(response => {
                if (response.status) {
                    notification['success']({
                        message: 'User update',
                        description: intl.formatMessage({ id: response.msg }),
                    });
                    refreshData();
                    modalIsOpenHandler(false);

                } else {
                    notification['error']({
                        message: 'User update',
                        description: intl.formatMessage({ id: response.msg }),
                    });

                    setButtonDisabled(false);
                }
            })
            .catch(error => {
                notification['error']({
                    message: 'User update',
                    description: "Error loading user data. Please refresh browser and try again!",
                });
                setButtonDisabled(false);
            });
    };

    return (

        <Modal
            open={modalIsOpen}
            title={<><PenIcon size={16} weight="light" /> <FormattedMessage id="profile-user-details" /></>}
            onCancel={() => modalIsOpenHandler(false)}
            width={750}
            footer={[
                <Button key="1" onClick={() => modalIsOpenHandler(false)}
                    icon={<XIcon size={16} />}>
                    <FormattedMessage id="cancel" />
                </Button>,
                <Button key="2"
                    disabled={buttonDisabled}
                    className="ant-btn-success"
                    loading={buttonDisabled}
                    onClick={handleSubmit(onSubmit)}
                    icon={!buttonDisabled && (<CheckSquareIcon size={16} weight="light" />)}>
                    <FormattedMessage id="save" />
                </Button>,
            ]}>

            {/* user basic */}
            <Card
                className="my-4"
                title={<FormattedMessage id="profile-user-details-info" />}>

                <UserFormView
                    formMode="edit"
                    control={control}
                    history={history}
                    userGroups={userGroups}
                    {...props}
                />

            </Card>
        </Modal>
    );
};

export default EditUserModal;
